import styled from 'styled-components';

export const NoDocuments = styled.p`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 5px 25px;
  background-color: var(--color-greyEC);
  border-radius: var(--border-radius8);
  color: var(--color-grey6A);
  font-weight: var(--font-weight400);
  font-size: var(--font-size18);
`;
